import React, { useState } from 'react';
import Videos from '../components/Videos';
import Photos from '../components/Photos';
import SwitchBanner from '../components/SwitchBanner/SwitchBanner';
import LinkFooter from '../components/LinkFooter/LinkFooter';

const MainPage = () => {
  const [activeSection, setActiveSection] = useState('Videos')
  const isVideos = activeSection === 'Videos';
  return (
    <div className="App">
      <SwitchBanner setActive={setActiveSection} />
      {isVideos ? <Videos /> : <Photos />}
      <LinkFooter />
    </div>
  );
}

export default MainPage;